/**
 * Convert a UTC date to local midnight, preserving the UTC calendar date.
 *
 * date-fns functions (differenceInMonths, differenceInYears, addDays) operate in local time.
 * When UTC midnight dates span a DST boundary, their local times differ:
 *   - June 10 00:00 UTC → 01:00 BST (local)
 *   - Dec 10 00:00 UTC  → 00:00 GMT (local)
 * This mismatch causes differenceInMonths to undercount by 1, because adding 6 months
 * to 01:00 local yields 01:00 local, which is AFTER 00:00 local on the same calendar day.
 *
 * Converting to local midnight ensures both dates have the same local time-of-day (00:00),
 * so date-fns arithmetic works correctly across DST transitions.
 */
export const utcToLocal = (date: Date | string): Date => {
  const dateObject = typeof date === 'string' ? new Date(date) : date
  return new Date(dateObject.getUTCFullYear(), dateObject.getUTCMonth(), dateObject.getUTCDate())
}
